import { createReducer, on } from '@ngrx/store';
import * as SachverhaltActions from './sachverhalt.actions';
import { initialState } from './sachverhalt.state';

export const sachverhaltReducer = createReducer(
  initialState,

  on(SachverhaltActions.openSelectMerkmalDialog, (state, { triggerElement }) => ({
    ...state,
    triggerElement,
  })),

  on(SachverhaltActions.openCreateSachverhaltDialog, (state, { triggerElement }) => ({
    ...state,
    triggerElement,
  })),

  on(SachverhaltActions.loadSachverhaltEditSet, (state, { sachverhaltEdit }) => ({
    ...state,
    sachverhaltEdit: { ...sachverhaltEdit },
  })),

  on(SachverhaltActions.startLoadingSachverhalt, state => ({
    ...state,
    isSachverhaltLoading: true,
  })),

  on(SachverhaltActions.loadSachverhaltEffect, state => ({
    ...state,
    isSachverhaltLoading: true,
  })),

  on(SachverhaltActions.loadSachverhaltSuccess, (state, { sachverhalt }) => ({
    ...state,
    sachverhalt: sachverhalt,
    isSachverhaltLoading: false,
  })),

  on(SachverhaltActions.setServerValidationError, (state, { serverValidationErrors }) => ({
    ...state,
    serverValidationErrors,
  })),

  on(SachverhaltActions.resetServerValidationError, state => ({
    ...state,
    serverValidationErrors: {
      invalidFields: [],
      summary: [],
    },
  })),

  on(SachverhaltActions.createSachverhalteSuccess, state => ({
    ...state,
  }))
);
